"use client";

import { SprintCalculator } from "@/components/sprint-calculator"

export default function SprintCalculatorPage() {
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Sprint Calculator</h1>
      <SprintCalculator />
    </div>
  )
}

